<template>
  <div class="lottery_wrap" ref="lotteryEl">
    <!-- NavBar -->
    <div class="title" ref="titleEl">
      <div class="icon" @click="back"><img :src="left" /></div>
      <div class="icon_text" @click="printLog">积分抽奖</div>
    </div>
    <!-- Background Image -->
    <img class="bg top" :src="bg1" />
    <img class="bg center" :src="bg2" />
    <img class="bg bottom" :src="bg3" />
    <!-- Game -->
    <div class="play_wrap">
      <template v-for="i in 9" :key="i">
        <div v-if="i === 5" class="space" @click="start">
          <div class="consume">消耗{{ info?.cost_score || "--" }}积分</div>
        </div>
        <div v-else class="item shadow">
          <img class="item_img" :src="i === actived ? item2 : item1" />
          <template v-if="i === 9 && info.prizes.length">
            <img class="item_icon" :src="thank" />
          </template>
          <template v-else>
            <img
              class="item_icon"
              :src="info.prizes[i - 1 > 3 ? i - 2 : i - 1]?.prize_img_url || ''"
            />
          </template>
          <div class="item_name">
            <template v-if="i === 9 && info.prizes.length">
              谢谢参与
            </template>
            <template v-else>
              {{ info.prizes[i - 1 > 3 ? i - 2 : i - 1]?.prize_name || "" }}
            </template>
          </div>
        </div>
      </template>
    </div>
    <!-- Other -->
    <img v-if="latest.length" class="bar1" :src="bar1" />
    <img class="bar2" :src="bar2" />
    <div v-if="latest.length" class="text1">
      <div class="ani">
        <span v-for="l in latest" :key="l.nickname" class="ani__item"
          >{{ l.nickname.trim()[0] }}**抽中了{{ l.prize_desc }}</span
        >
      </div>
    </div>
    <RouterLink class="text2" to="/lottery/rule">规则说明</RouterLink>
    <div class="text3">
      <div>今日剩余抽奖次数：{{ info?.remain_num_today || "--" }}</div>
      <div>剩余积分：{{ info?.remain_score || "--" }}</div>
    </div>
    <RouterLink class="text4" to="/lottery/record">我的中奖记录</RouterLink>
  </div>
  <!-- Dialog -->
  <div v-if="dialog1Visible" class="dialog1">本次没抽中，谢谢参与</div>
  <div v-if="dialog2Visible" class="dialog2">
    今天的抽奖次数用完啦，明天再来吧！
  </div>
  <div v-if="dialog3Visible" class="dialog3">
    <div class="dialog3_text">积分不足，请获得积分后再来吧！</div>
    <div class="dialog3_ok" @click="ok">知道了</div>
  </div>
  <div v-if="isRealNameDialog" class="dialog3">
    <div class="dialog3_text">请先完成实名认证后再参加活动!</div>
    <div class="dialog3_cancle" @click="realNameCancle">取消</div>
    <div class="dialog3_ok" @click="realNameOk">去认证</div>
  </div>
  <div v-if="happyVisible" class="happy">
    <img class="happy_icon1" :src="title" />
    <img class="happy_icon2" :src="close" @click="handleClose" />
    <img class="happy_icon3" :src="prizeInfo.imgUrl" />
    <div class="happy_text1">
      获得{{ prizeInfo.name }}
      <span v-if="Number(prizeInfo.prize_type) === 2"
        >* {{ prizeInfo.number }}</span
      >
    </div>
    <div class="happy_text2">请到【我的中奖记录】查看</div>
  </div>
  <!-- Mask -->
  <div v-if="maskVisible" class="gray"></div>
</template>
<style scoped>
@import url(./helper/index.css);
.ani {
  width: 178px;
  /* overflow: hidden; */
  white-space: nowrap;
  animation: marquee v-bind(cssBind.s) linear infinite;
}
@keyframes marquee {
  0% { transform: translateX(100%); }
  100% { transform: translateX(v-bind(cssBind.t)); }
}
.ani__item {
  width: 178px;
  display: inline-block;
}
</style>
<script setup>
import { RouterLink } from "vue-router";
import { play, generateRgba } from "./helper";
import {
  bg1,
  bg2,
  bg3,
  item1,
  item2,
  bar1,
  bar2,
  left,
  title,
  close,
  thank,
} from "./helper/import";
import {
  computed,
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  createVNode,
} from "vue";
import { duringApi, drawApi, latestApi } from "./helper/api";
import store from "@/store";
import { onMountedOrActivated } from "./helper/onMountedOrActivated";
import { Toast, Dialog } from "@nutui/nutui";
const easyearn = window.easyearn
const info = ref({ prizes: [] }); // 活动信息
const latest = ref([]); // 最近中奖轮播
const actived = ref(0); // 九宫格item高亮index
const target = ref(0); //  转动停止item
const dialog1Visible = ref(false); // 谢谢参与
const dialog2Visible = ref(false); // 次数用尽
const dialog3Visible = ref(false); // 积分不足
const happyVisible = ref(false); // 恭喜中奖
const isRealNameDialog = ref(false); // 是否实名弹框
const prizeInfo = reactive({
  // 中奖奖品信息
  name: "",
  number: "",
  imgUrl: "",
  prize_type: "",
});
const maskVisible = computed(() => dialog3Visible.value || happyVisible.value);
let isRun = false; // 防止重复运行
const start = async () => {
  if (isRun) {
    Toast.text("抽奖已进行！");
    return;
  }
  if (info.value.lottery_id === undefined) {
    Toast.text("活动暂未开放！");
    return;
  }
  if (Number(info.value.remain_num_today) <= 0) {
    // 今天没有抽奖次数了
    dialog2Visible.value = true;
    setTimeout(() => {
      dialog2Visible.value = false;
    }, 2500);
    return;
  }
  if (Number(info.value.remain_score) < Number(info.value.cost_score)) {
    // 剩余积分不够本次抽奖了
    dialog3Visible.value = true;
    return;
  }
  Dialog({
    title: "确认抽奖",
    content: createVNode(
      "span",
      {},
      `本次抽奖将消耗您${info.value?.cost_score || 0}积分！`
    ),
    onOk,
  });
  async function onOk() {
    isRun = true;
    const res = await drawApi({
      lottery_id: info.value.lottery_id,
    }).catch(() => {
      Toast.text("系统忙碌，请稍后再试！");
      isRun = false; // 因接口异常导致抽奖运行失败
    });
    // 用户未实名认证
    if(res.code == '80018') {
      isRun = false;
      isRealNameDialog.value = true; 
      return
    }
    const { is_win, prize } = res.data; // 拉取中奖信息
    if (is_win && prize) {
      // 含中奖信息
      const {
        prize_id,
        prize_name,
        prize_number,
        prize_img_url,
        prize_type,
      } = prize;
      prizeInfo.name = prize_name;
      prizeInfo.number = prize_number;
      prizeInfo.imgUrl = prize_img_url;
      prizeInfo.prize_type = prize_type;
      info.value.prizes.forEach((item, index) => {
        if (item.prize_id === prize_id) {
          // 从8个item中匹配到中奖item
          target.value = index > 3 ? index + 2 : index + 1;
        }
      });
    } else {
      // 不含中奖信息
      prizeInfo.name = undefined;
      prizeInfo.number = undefined;
      prizeInfo.imgUrl = undefined;
      prizeInfo.prize_type = undefined;
      target.value = 9;
    }
    play(actived, target.value, () => {
      isRun = false;
      if (is_win && prize) {
        // 中奖了
        happyVisible.value = true;
      } else {
        // 谢谢参与
        dialog1Visible.value = true;
        setTimeout(() => {
          dialog1Visible.value = false;
        }, 2500);
      }
    });
    // 抽奖完刷新次数
    const { code, data } = await duringApi();
    if (Number(code) === 0) {
      info.value = data;
    }
  }
};
// 是否实名弹框
const realNameOk = () => {
  // 跳转到实名认证页面
  easyearn.goIdentityVerifyPage()
  realNameCancle()
}
const realNameCancle = () => {
  isRealNameDialog.value = false 
}

const back = () => {
  window.easyearn?.goBack();
};
const handleClose = () => {
  happyVisible.value = false;
};
const cssBind = reactive({
  s: '', // 跑马灯总时长
  t: '' // 跑马灯位移总距离
});
onMountedOrActivated(async () => {
  const res = await duringApi();
  // 拉取活动信息
  const { code, data } = res;
  if (code !== "0") return;
  info.value = data;
  if (!data.lottery_id) return;
  store.commit("lottery/SET_LOTTERY_ID", data.lottery_id);
  const res2 = await latestApi({ lottery_id: data.lottery_id });
  // 拉取最近中奖名单
  latest.value = res2.data.prize_winners || [];
  if (!latest.value) return;
  cssBind.s = `${latest.value.length * 5}s`
  cssBind.t = `-${latest.value.length * 100}%`
});
const printLog = async () => {
  const res = await duringApi();
  // 拉取活动信息
  const { code, data } = res;
  if (code !== "0") return;
  info.value = data;
};
const ok = () => {
  dialog3Visible.value = false;
};
// 根据滚动条高度让NavBar背景渐变，由浅到深
const lotteryEl = ref(null);
const titleEl = ref(null);
onMounted(async () => {
  lotteryEl.value.addEventListener("scroll", onScroll);
});
onBeforeUnmount(() => {
  lotteryEl.value.removeEventListener("scroll", onScroll);
});
function onScroll(e) {
  titleEl.value.style.backgroundColor = generateRgba(
    [61, 147, 246],
    e.target.scrollTop
  );
}
</script>
